export default class ClipboardCopyUtils {
    static copyToClipboard(text) {
        // @ts-ignore use new clipboard api if available
        if (navigator.clipboard) {
            // @ts-ignore
            navigator.clipboard.writeText(text);
        }
        else {
            const tempElement = document.createElement("textarea");
            tempElement.innerHTML = text;
            document.body.appendChild(tempElement);
            tempElement.select();
            document.execCommand("copy");
            tempElement.remove();
        }
    }
}
//# sourceMappingURL=ClipboardCopyUtils.js.map